import DataGrid, {
  Column,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
  Editing,
  HeaderFilter,
  StringLengthRule,
} from "devextreme-react/data-grid";
import { Button, SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";
import { NAVIGATION } from "./mock";

const LanguageList = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "ja", name: "Japanese", nativeName: "日本語 (にほんご／にっぽんご)" },
  { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
];

export default function DictionaryTableList({
  dataSource,
  dataGrid,
  middleware,
  onValueChanged,
}) {
  const changeDisplayedName = () => {
    const language = localStorage.getItem("locale");
    const object = {
      vi: "textVi",
      en: "text",
      ja: "textJa",
    };
    return object[language] ?? "textVi";
  };

  const { isXSmall, isSmall } = useScreenSize();
  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        dataSource={dataSource}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        columnAutoWidth={true}
        rowAlternationEnabled={true}
        ref={dataGrid}
        alignment="center"
      >
        <HeaderFilter visible="true" />
        <Editing
          mode="row"
          useIcons={true}
          allowUpdating={middleware.WriteState && middleware.WriteState}
          allowAdding={false}
          allowDeleting={false}
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />

        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column type="buttons">
          <Button name="edit" />
        </Column>
        <Column
          caption={formatMessage("Language")}
          dataField="LanguageId"
          allowEditing={false}
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={LanguageList}
            displayExpr="name"
            valueExpr="code"
            showClearButton={true}
          />
        </Column>
        <Column
          caption={formatMessage("Key")}
          dataField="DictionaryKey"
          dataType="string"
          allowEditing={false}
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("DisplayText")}
          dataField="DisplayText"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <StringLengthRule max="300" />
        </Column>
        <Column
          caption={formatMessage("Remarks")}
          dataField="Remarks"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <StringLengthRule max="300" />
        </Column>

        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          >
            <div className="form_select_box_list">
              {middleware.ReadState && (
                <>
                  <span className="name">{formatMessage("Navigation")}: </span>
                  <SelectBox
                    dataSource={NAVIGATION}
                    valueExpr="ItemCode"
                    grouped={true}
                    width={300}
                    groupRender={(item) => {
                      const language = changeDisplayedName();
                      return (
                        <div className="form_select_box_group">
                          <span className="name">{item[language]}</span>
                        </div>
                      );
                    }}
                    displayExpr={changeDisplayedName()}
                    onValueChanged={onValueChanged}
                  />
                </>
              )}
            </div>
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
